import { Theme } from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";

type BriefCardStylesProps = {
    isDisabled: boolean;
    isCompleted: boolean;
};

const BriefCardStyles = makeStyles<Theme, BriefCardStylesProps>((theme: Theme) =>
    createStyles({
        cardWrapper: {
            border: ({ isDisabled }: BriefCardStylesProps) =>
                `1px solid ${isDisabled ? theme.palette.neutrals.main : theme.palette.others.green700}`,
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1.5),
        },
        cardInner: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 0,
        },
        mainInfo: {
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
        },
        newButton: {
            height: "100%",
            minWidth: "auto",
            padding: theme.spacing(2),
            backgroundColor: ({ isDisabled }: BriefCardStylesProps) =>
                isDisabled ? theme.palette.success.light : theme.palette.success.main,
            borderRadius: theme.spacing(1),
            color: theme.palette.common.white,
            "&:hover": {
                backgroundColor: ({ isDisabled }: BriefCardStylesProps) =>
                    isDisabled ? theme.palette.success.main : theme.palette.success.dark,
            },
            "& .MuiSvgIcon-root": {
                fontSize: ({ isDisabled }: BriefCardStylesProps) => (isDisabled ? 18 : 24),
                color: "inherit",
                marginRight: theme.spacing(2),
                transition: "transform 0.3s ease",
            },
            "&:hover .MuiSvgIcon-root": {
                transform: "scale(0.8)",
            },
            "& .MuiTypography-root": {
                color: "inherit",
                textAlign: "center",
            },
        },
        cardTitle: {
            position: "relative",
            display: "flex",
            maxWidth: 120,
            color: theme.palette.text.primary,
            marginBottom: "2px",
            "& > div": {
                fontSize: 16,
                fontWeight: 500,
            },
        },
        briefSubtitle: {
            fontSize: 11,
            marginBottom: theme.spacing(1),
            color: ({ isDisabled }: BriefCardStylesProps) =>
                isDisabled ? theme.palette.text.primary : theme.palette.common.white,
        },
        chipsWrapper: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            marginBottom: theme.spacing(0.5),
            marginRight: theme.spacing(0.5),
            backgroundColor: theme.palette.neutrals.light,
            padding: theme.spacing(0.5, 1.2),
            backdropFilter: "blur(10px)",
            boxShadow:
                "0px 1px 4px rgba(0, 0, 0, 0.03), 0px 5px 5px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.03)",
            "&:hover": {
                backgroundColor: theme.palette.neutrals.light,
            },
            "&:active": {
                boxShadow:
                    "0px 1px 4px rgba(0, 0, 0, 0.03), 0px 5px 5px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.03)",
            },
            "&.Mui-disabled": {
                cursor: "none",
                opacity: 1,
            },
            "& .MuiChip-label": {
                fontWeight: 600,
                padding: 0,
                marginRight: theme.spacing(0.5),
                "& + div": {
                    minWidth: 16,
                    height: 16,
                },
            },
        },
        actionsWrapper: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            flexDirection: ({ isCompleted }: BriefCardStylesProps) => (isCompleted ? "row-reverse" : "row"),
            marginBottom: ({ isCompleted }: BriefCardStylesProps) => (isCompleted ? 0 : theme.spacing(1.3)),
        },
    })
);

export default BriefCardStyles;
